<template>
    <div class="modal-card card">
        <form>
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">
                    Delete aUT Credential(s)
                </h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body">
                <p>{{ `Are you sure you want to delete the following aUT credential(s)?` }}</p>
                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th class="w-40">Salt ID</th>
                            <th class="w-60 url-column">URL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="cred in credentials" :key="cred.saltID">
                            <td>{{ cred.saltID }}</td>
                            <td class="url-column">{{ cred.url }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-end align-items-center">
                    <button type="button" class="btn btn-danger" @click="handleSubmit" :disabled="loading">
                        <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div v-else>
                            Delete
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: {
        modalData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            credentials: null,
        }
    },
    name: "AddAutCredential",
    methods: {
        ...mapActions('aut', {
            deleteCredentials: 'deleteAutCredentials'
        }),
        async handleSubmit() {
            this.loading = true;
            try {
                const deletePromises = this.credentials.map(cred => {
                    return this.deleteCredentials(cred.saltID);
                });
                const results = await Promise.allSettled(deletePromises);

                let successfulDeletions = 0
                results.forEach((res, idx) => {
                    const cred = this.credentials[idx];

                    if (res.status === "fulfilled") {
                        console.log(`Deleted credential: ${cred.saltID}`);
                        successfulDeletions++;
                    } else {
                        console.error(`Failed to delete credential: ${cred.saltID}\nReason: ${res.reason.message}`);
                        let toastoptions = {
                            message: res.reason.message || "Error deleteing credential",
                            type: "error",
                        };
                        this.$store.dispatch('addToast', toastoptions);
                    }
                });
                if (successfulDeletions == this.credentials?.length) {
                    let toastoptions = {
                        message: "Credential(s) deleted successfully",
                        type: "success",
                    };
                    this.$store.dispatch('addToast', toastoptions);
                    this.$store.dispatch("hideModal");
                    if (typeof this.modalData?.refreshCredentials === 'function') {
                        this.modalData.refreshCredentials();
                    }
                }
            } catch (error) {
                let err = error.response?.data.error ? error.response.data.error : error.message;
                console.error(err)
            } finally {
                this.loading = false;
            }
        }
    },
    beforeMount() {
        this.credentials = this.modalData?.credentials;
    }
};
</script>

<style scoped>
.url-column {
    max-width: none !important;
    white-space: normal !important;
    word-wrap: break-word;
    word-break: break-all;
    overflow-wrap: break-word;
    min-width: 200px;
}

table {
    table-layout: auto;
    width: 100%;
}
</style>